/** What GET /api/health says about the code the hub runs and the bundle it serves. */
export interface HubBuildInfo {
  /** The commit the hub process runs. */
  sha: string | null;
  /** The commit of the web bundle the hub started serving (null from a hub older than that stamp). */
  page: string | null;
}

/**
 * This page was built from other code than the hub runs: it matches neither the hub's commit nor
 * the bundle the hub started serving. A bundle Turbo replayed from its cache carries the commit it
 * was built at, older than the hub's when only other units changed since, and is not stale: the
 * hub serves that very bundle. A bundle rebuilt after the hub started is. An unknown hub commit
 * is no evidence either way.
 */
export function isPageStale(pageSha: string, health: HubBuildInfo): boolean {
  if (!pageSha || !health.sha) return false;
  return pageSha !== health.sha && pageSha !== health.page;
}
